/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
// import {
//   AppBar,
//   Toolbar,
//   Avatar,
//   IconButton,
//   Menu,
//   MenuItem,
//   Divider,
// } from "@mui/material";

// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemText from "@mui/material/ListItemText";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import Collapse from "@mui/material/Collapse";
// import ArrowRightIcon from "@mui/icons-material/ArrowRight";
// import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
// import List from "@mui/material/List";
import { useAuth } from "../../context/authContext";
// import SummarizeIcon from "@mui/icons-material/Summarize";
// import AssessmentIcon from "@mui/icons-material/Assessment";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// import ArticleIcon from "@mui/icons-material/Article";
// import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

// import { useAuth } from "../../context/authContext";
import { getModulesByUserData } from "../../redux/features/authSlice";
// import Footer from "../footer/Footer";

const Sidebar = () => {
  const { modulesByUserData } = useSelector((state) => ({
    ...state.authReducer,
  }));
  const { logout } = useAuth();
  //   const navigate = useNavigate();

  // Sidebar links

  const handleLogout = async () => {
    // e.preventDefault();
    await logout();
    window.location.reload();
    // navigate("/login");
  };
  useEffect(() => {
    dispatch(getModulesByUserData());
  }, []);

  // console.log(modulesByUserData, "modulesByUserData")
  const [userData, setUserData] = useState(false);
  const [conversionData, setConversionData] = useState(false);
  const [performanceData, setPerformanceData] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toggleState = (state, setState) => {
    setState(!state);
  };
  // console.log(modulesByUserData, "modulesByUserData");
  const closeSidebar = () => {
    if (window.innerWidth < 1200) {
      document.body.classList.remove("toggle-sidebar");
    }
  };

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        {modulesByUserData &&
          modulesByUserData.map((row) =>
            row.sub_module === null ? (
              <li className="nav-item" key={row.module_url && row.module_url}>
                <NavLink
                  to={`${row.module_url && row.module_url}`}
                  className="nav-link"
                  onClick={closeSidebar}
                >
                  <i
                    style={{ fontSize: "19px" }}
                    className={`bi ${row.icon && row.icon}`}
                  ></i>
                  <span className="text-capitalize">
                    {row.module_name && row.module_name}
                  </span>
                </NavLink>
              </li>
            ) : (
              <li
                className="nav-item"
                key={`dropdown-${"xyz" + row.module_id}`}
              >
                <a
                  className="nav-link collapsed"
                  data-bs-target={`#${"xyz" + row.module_id}-nav`}
                  data-bs-toggle="collapse"
                >
                  <i
                    style={{ fontSize: "19px" }}
                    className={`bi ${row.icon && row.icon}`}
                  ></i>
                  <span className="text-capitalize">
                    {row.module_name && row.module_name}
                  </span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </a>
                <ul
                  id={`${"xyz" + row.module_id}-nav`}
                  className="nav-content collapse "
                  data-bs-parent="#sidebar-nav"
                >
                  {row.sub_module &&
                    row.sub_module.map((item) => (
                      <li key={item.sub_module_url}>
                        <NavLink
                          to={`${item.sub_module_url && item.sub_module_url}`}
                          className="nav-link"
                          onClick={closeSidebar}
                        >
                          <i className="bi bi-caret-right-fill"></i>
                          <span className="text-capitalize">
                            {item.sub_module_name && item.sub_module_name}
                          </span>
                        </NavLink>
                      </li>
                    ))}
                </ul>
              </li>
            )
          )}
        <li className="nav-item" key={"login"}>
          <a onClick={() => { handleLogout(); closeSidebar(); }} className="nav-link" style={{cursor: "pointer"}}>
            <i className={`bi ${"bi-box-arrow-right"}`}></i>
            <span className="text-capitalize">{"logout"}</span>
          </a>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
